var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.017,
    height: 43.858,
    viewBox: "0 0 55.017 43.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M15.064,23.382c-.064-7.317-.4-14.725-1.03-22L24.2,1.117c-.165,3.859-.426,7.576-.746,11.4q-.476,5.661-1.177,11.305Z",
    transform: "translate(-2.138 -0.17)",
    fill: "#738bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M42.451,24.376A56.312,56.312,0,0,1,40.522,0l9.941,2.156a50.7,50.7,0,0,0-1.629,15.258,38.747,38.747,0,0,0,.593,5.072Z",
    transform: "translate(-6.093)",
    fill: "#738bff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M55.017,37.483C43.7,48.3,28.183,51.355,13.429,46.334A51.793,51.793,0,0,1,0,39.729l6.23-8.04c.065.058.3.236.465.363A40.786,40.786,0,0,0,28.218,39.99c8.1.421,15.783-2.685,22-7.912l4.8,5.4",
    transform: "translate(0 -4.828)",
    fill: "#738bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.331c419ce6f0163dc2d41cf2a3749a10.svg";
export { ForwardRef as ReactComponent };